module.exports = __webpack_public_path__ + "img/mute.08e385ed.svg";